import apiClient from './index';

export default {
    login(studentId, username) {
        return apiClient.get(`/user/login?studentId=${studentId}&username=${encodeURIComponent(username)}`);
    },
    register(data) {
        return apiClient.post('/auth/register', data);
    },
    getCurrentUser() {
        return apiClient.get('/auth/me');
    },
    changePassword(data) {
        return apiClient.post('/auth/change-password', data);
    },
    logout() {
        return apiClient.post('/auth/logout');
    }
}; 